import { openapi_website_cms_getMarketFiltersForSport, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_getMarketFiltersForSport';
import  { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type MarketFilterType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface MarketFiltersForSportParams {
    sport: string
}

export const getMarketFiltersForSport = {
    browser: {
        params: (params: MarketFiltersForSportParams): ParamsFetchType<MarketFiltersForSportParams> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get-market-filters-sport',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get-market-filters-sport',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<MarketFiltersForSportParams>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_getMarketFiltersForSport(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            sport: params.req.body.sport
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
